import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchLaunchingSoonRanking } from '../services/api';
import {LeaderboardItem } from '../types';
import '../styles/Ranking.css';


const LaunchingSoon: React.FC = () => {
  const [launchingSoonData, setLaunchingSoonData] = useState<LeaderboardItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lastUpdated, setLastUpdated] = useState<string>('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [launchingSoonData] = await Promise.all([
          fetchLaunchingSoonRanking(),
        ]);
        setLaunchingSoonData(launchingSoonData);
        setLastUpdated(new Date().toLocaleString('en-US', { timeZone: 'UTC' }));
      } catch (err) {
        setError('Failed to fetch ranking data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleRowClick = (item: LeaderboardItem) => {
    if (item.StoreUrl) {
      if (item.StoreUrl.startsWith('http://') || item.StoreUrl.startsWith('https://')) {
        // External link
        window.open(item.StoreUrl, '_blank', 'noopener,noreferrer');
      } else {
        // Internal link
        navigate(item.StoreUrl);
      }
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="ranking-container">
      <h1 className="ranking-title">Weirdly.fuN <span className="ranking-title-highlight">Launching Soon</span></h1>
      <p className="ranking-update-time">The data was last updated at {lastUpdated} (UTC)</p>

      <div className="ranking-tables-container-top">
        <div className="ranking-table-wrapper">
          <h2 className="table-title">Launching Soon!</h2>
          <p className="table-subtitle">
            These tokens will be launched when the game is released. Tokens are automatically minted and launched by
            Weirdly contracts when any game listed below is available for purchase or for play by the general public
            on <a href={"https://store.steampowered.com/"} className="launching-soon-link" target={"_blank"} rel="noreferrer">Steam</a>, <a href={"https://store.epicgames.com/"} className="launching-soon-link" target={"_blank"} rel="noreferrer">Epic</a>,
            or <a href={"https://store.hyperplay.xyz/"} className="launching-soon-link" target={"_blank"} rel="noreferrer">HyperPlay</a>.
          </p>
          <table className="ranking-table">
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Description</th>
                <th>Launching</th>
              </tr>
            </thead>
            <tbody>
              {launchingSoonData.map((item, index) => (
                <tr key={index} onClick={() => handleRowClick(item)} className="clickable-row">
                  <td><img src={`../game-images/${item.LogoUrl}`} alt={item.Name} className="game-logo-2" /></td>
                  <td>
                    <span className="launching-time-name">{item.Name}</span>
                  </td>
                  <td className="launching-time-description">{item.Description}</td>
                  <td className="launching-time">{item.LaunchTime}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LaunchingSoon;